import axios from "axios";

export default {
  areas() {
    return axios.get("cleaning_areas");
  },
};
